import React from "react"

class Navigation extends React.Component {
  render() {
    return (
      <div className="left-0 bottom-0 top-0 overflow-auto shadow sm:scrollbar sm:shadow-none min-w-xxs mt-2" id="sidebar">
        <div className="flex flex-row md:flex-col">
          {this.props.children}
        </div>
      </div>
    )
  }
}


export default Navigation
